import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19 5 5 19m14 0L5 5"
	})
});
export default SvgKgClose;
